import { Badge } from "@/components/ui/badge";
import type { OpportunityView } from "@/generated/api/model";

export function StatusBadges({ view }: { view: OpportunityView }) {
    const { status } = view.window;
    return (
        <span className="flex flex-wrap gap-1">
            <Badge variant={status === "open" ? "warning" : status === "interrupted" ? "outline" : "default"}>
                {status}
            </Badge>
            {view.actionable && <Badge variant="success">actionable</Badge>}
        </span>
    );
}
